import { type EditorState } from '@atlaskit/editor-prosemirror/state';

import type { ReadingAidsPopupProps } from '../../types';

type SelectionProps = Pick<
	ReadingAidsPopupProps,
	'selectionRect' | 'selectedText' | 'selectionRange'
>;

export const getReadingAidsSelectionProps = (state?: EditorState): SelectionProps | null => {
	if (!state || !state.selection || state.selection.empty) {
		return null;
	}
	const selection = window.getSelection();
	if (!selection || !selection.rangeCount) {
		return null;
	}

	const range = selection.getRangeAt(0);

	if (!range || range.collapsed) {
		return null;
	}
	const { from, to } = state.selection;
	const selectedText = state.doc.textBetween(from, to, '\n');

	return {
		selectionRange: range,
		selectionRect: range.getBoundingClientRect(),
		selectedText,
	};
};
